import { Switch } from '@headlessui/react';
import clsx from 'clsx';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function NotificationSwitch(props: Props) {
  const { checked, onChange } = props;

  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={clsx(
        checked ? 'bg-primary-600' : 'dark:bg-dark-surface bg-gray-200',
        'focus:ring-primary-500 dark:focus:ring-offset-dark-bg relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-auto'
      )}
    >
      <span
        aria-hidden="true"
        className={clsx(
          checked ? 'translate-x-5' : 'translate-x-0',
          'inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
        )}
      />
    </Switch>
  );
}

export default NotificationSwitch;
